import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.532 11.5a10.033 10.033 0 1 0-19.3 3.84 10 10 0 0 0 2.024 3.096 5.52 5.52 0 0 1 4.852-2.885h4.784l.222.004a5.52 5.52 0 0 1 4.629 2.881 10 10 0 0 0 2.025-3.097c.504-1.217.764-2.522.764-3.839M9.108 17.019a4.05 4.05 0 0 0-3.714 2.437c.694.533 1.455.976 2.267 1.312a10.03 10.03 0 0 0 7.678 0c.812-.336 1.572-.78 2.267-1.312a4.05 4.05 0 0 0-1.293-1.635 4.05 4.05 0 0 0-2.42-.802zm5.247-7.911a2.855 2.855 0 1 0-5.71 0 2.855 2.855 0 0 0 5.71 0M23 11.5a11.5 11.5 0 0 1-3.368 8.132q-.309.305-.639.586a11.499 11.499 0 0 1-3.093 1.907A11.5 11.5 0 1 1 23 11.5m-7.177-2.392a4.323 4.323 0 1 1-8.647-.002 4.323 4.323 0 0 1 8.647.002" }, null, -1)
  ]))]))
}
export default { render: render }